import { t } from 'i18next';
import { GridFlex, PageCardWithEvenPadding, Text } from '@stigg-components';
import { ZuoraIntegrationForm, ZuoraIntegrationFormProps } from './ZuoraIntegrationForm';

export function ZuoraIntegrationEdit(props: ZuoraIntegrationFormProps) {
  if (!props.integration) {
    return null;
  }

  return (
    <GridFlex.Column gap={4}>
      <Text.B1 color="primary" $bold>
        {t('integrations.details')}
      </Text.B1>
      <PageCardWithEvenPadding>
        <ZuoraIntegrationForm {...props} />
      </PageCardWithEvenPadding>
    </GridFlex.Column>
  );
}
